/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type BrregSearchItem,
    BrregSearchItemFromJSON,
    BrregSearchItemToJSON,
} from '../models/BrregSearchItem';

export interface ApiLegalEntitiesSearchGetRequest {
    name?: string;
}

/**
 * 
 */
export class LegalEntitiesApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiLegalEntitiesSearchGet without sending the request
     */
    async apiLegalEntitiesSearchGetRequestOpts(requestParameters: ApiLegalEntitiesSearchGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/legal-entities/search`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiLegalEntitiesSearchGetRaw(requestParameters: ApiLegalEntitiesSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BrregSearchItem>>> {
        const requestOptions = await this.apiLegalEntitiesSearchGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BrregSearchItemFromJSON));
    }

    /**
     */
    async apiLegalEntitiesSearchGet(requestParameters: ApiLegalEntitiesSearchGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BrregSearchItem>> {
        const response = await this.apiLegalEntitiesSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
